import type {
  TDependent,
  TDependentInvitation,
} from '@cascade/api-client/dependents';
import type { TDependentRow, TDependentStatus } from './Dependents.types.ts';

const buildDependentRow = (
  { email, name }: TDependent | TDependentInvitation,
  status: TDependentStatus,
): TDependentRow => ({
  id: email,
  email,
  name: name || undefined,
  status,
});

export const buildDependentRows = (
  activeDependents: TDependent[],
  pendingInvitations: TDependentInvitation[],
): TDependentRow[] => [
  ...activeDependents.map((dependent) =>
    buildDependentRow(dependent, 'active'),
  ),
  ...pendingInvitations.map((invitation) =>
    buildDependentRow(invitation, 'pending'),
  ),
];
